// extracted by mini-css-extract-plugin
export default {"container":"_inbox-container_container__AE1zE"};